import mainApiClient from '../interceptor.mainApiClient';

const smartyEndpoints = {
  reverseGeocode: (config) =>
    mainApiClient.get('/api/v1/smarty/reverse-geocode', config),
};

export default smartyEndpoints;
